import React, { useMemo } from 'react';
import { BotEditProfileDialog, editProfileIdMap } from '@colonist/clientforge';
import { LobbyImage } from '@colonist/types';
import { getLobbyImagePath } from '../../ui_utils/Utils.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { buildColorOptions } from './buildEditProfileOptions.ts';
import { useEditProfileInfo } from './useEditProfileInfo.ts';
import { createColorSelectHandler, goToStoreColors } from './editProfileColorSelection.ts';
export const BotEditProfileDialogContainer = ({ open, onClose, selectColorAction, selectedColor, username })=>{
    const info = useEditProfileInfo(open);
    const colors = useMemo(()=>info == undefined ? [] : buildColorOptions(info.availableColors), [
        info
    ]);
    if (info == undefined) return null;
    const shouldHideStoreActions = UIUtilsEjsVariables.shouldHideStoreOnMobile;
    const selectColor = createColorSelectHandler({
        selectColorAction: selectColorAction,
        isRoomColor: true,
        onClose: onClose
    });
    return /*#__PURE__*/ React.createElement(BotEditProfileDialog, {
        open: open,
        onClose: onClose,
        username: username,
        icon: getLobbyImagePath(LobbyImage.Bot),
        colors: colors,
        selectedColor: editProfileIdMap.toColorId(selectedColor),
        onColorSelect: selectColor,
        shouldHideStoreActions: shouldHideStoreActions,
        onGoToStoreColors: goToStoreColors
    });
};
